/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
import {
  maxMobile,
  maxWidth,
  minWidthApp,
  primaryColor,
  primaryFont,
  retina,
  wMedium,
} from 'Utils/utilsStyle';
import classNames from 'classnames';
import CompanyCardLarge from 'Components/common/components/CompanyCardLarge';
import CompanySkeleton from 'Components/common/skeleton/CompanySkeleton';
import { selectFollowedCompanies, selectRecommendedCompanies, selectRecommendedCompaniesLoading } from 'Selector/OnboardingSelector';
import { useDispatch, useSelector } from 'react-redux';
import { companiesData, selectCompanyResultsEnded, selectLoading } from 'Selector/GlobalSearchResultsSelector';
import AlertsSearch from 'Components/alerts/components/AlertsSearch';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useEffect, useRef, useState } from 'react';
import { SearchResultsRequest } from 'Types/GlobalSearchResultsTypes';
import { actions as globalSearch } from 'Slice/GlobalSearchResultsSlice';
import { getCurrentTime, getLangCookie, valueToObject } from 'Utils/UtilityFunctions';
import { actions as flurryActions } from '../../Slice/HelperSlice';
import NoDataFoundComponent from './NoDataFoundComponent';

const StyleWrapper = styled.div`
.company-skeleton {
  @media all and (max-width: ${maxMobile}) {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
  }
  .person-skeleton-wrapper {
    width: 100%;
    .person-box {
      width: 162px;
      height: 112px;
      margin-bottom: 14px;
      @media all and (max-width: ${maxWidth}), ${retina} {
        width: 100%;
        height: 114px;
      }
      @media all and (max-width: ${maxMobile}) {
        height: 75px;
        width: 100%;
        margin: 0px auto 8px 0px;
      }
    }
    .title-box {
      margin: 0px auto 9px;
      @media all and (max-width: ${maxMobile}) {
        height: 16px;
        margin: 0px 0px 5px 0px;
      }
    }
    .title-box-short {
      margin: 0px auto 9px;
      @media all and (max-width: ${maxMobile}) {
        height: 16px;
        margin: 0px 0px 5px 0px;
      }
    }
    .btn {
      @media all and (max-width: ${maxMobile}) {
        height: 30px;
        width: 100%;
      }
    }
  }
}
.company-card {
  margin-bottom: 33px; 
  @media all and (max-width: ${maxWidth}), ${retina} {
    margin-bottom: 20px; 
  }      
  .company-item {
    @media all and (max-width: ${maxMobile}) {
      width: 110px;
      max-width: 110px;
    }
    .check_label {
      .exceptButtonContent {
        .company-image-parent {
          width: 162px;
          height: 122px;
          margin: 0 auto 10px;
          @media all and (max-width: ${maxWidth}), ${retina} {
            width: 150px;
            height: 114px;
          }
          @media all and (max-width: ${minWidthApp}) {
            width: 90%;
          }
          @media all and (max-width: ${maxMobile}) {
            height: 75px;
            width: 100px;
          }
        }
        .company-naves {
          &.compnayNavsOnboarding {
            display:flex;
            flex-direction:column;
            align-items:center;
          }
          .disabled-button {
            background-color: transparent;
            border:0px;
            cursor: default;
          }
          .companyName {
            margin-bottom: 5px;
            font-size: 18px;
            line-height: 21px !important;
            @media all and (max-width: ${maxWidth}), ${retina} {
              font-size: 16px;
              line-height: 19px !important;
            }
            @media all and (max-width: ${maxMobile}) {
              font-size: 12px;
              line-height: 15px !important;
            }
          }
          .company-stats {
            p {
              margin-bottom: 5px;
              font-size: 11px;
              &:nth-child(1){
                margin-left: 0px;
                padding-right: 10px;
              }
              @media all and (max-width: ${maxWidth}), ${retina} {
                font-size: 10px;
              }
              @media all and (max-width: ${maxMobile}) {
                font-size: 7px;
              }
            }
            .seperator {
              margin-top: -9px
            }
          }
          .company-website-link-wrapper {
            .company-website {
              .world-icon-svg {
                display: none;
              }
              span {
                color: ${primaryColor};
                text-align: center;
                font-family: ${primaryFont};
                font-size: 12px;
                font-weight: ${wMedium};
                line-height: 16px;
                letter-spacing: -0.424px;
              }
            }
          }
          .follow-action {
            @media all and (max-width: ${maxMobile}) {
              height: 24px;
            }
            .small-button-chinese {
              margin-bottom: 0px;
              font-size: 16px;
              @media all and (max-width: ${maxWidth}), ${retina} {
                font-size: 14px;
              }
              @media all and (max-width: ${maxMobile}) {
                font-size: 10px;
                padding: 4px 15px;
              }
            }
          }
        }
      }
    }
  }
}
`;

type Props = {
  // setQueryData: (val: string) => void,
  // queryData: string,
  activeIndex: number,
  // fetchMore: () => void
};

const FollowCompanyComponent = function FollowCompanyComponent(props: Props) {
  const {
    activeIndex,
    // queryData,
    // setQueryData,
    // searchTerm,
    // onSearching,
    // fetchMore,
  } = props;

  const [queryData, setQueryData] = useState('');

  const loading = useSelector(selectRecommendedCompaniesLoading);
  const companiesLoading = useSelector(selectLoading);
  const recommendedCompanies = useSelector(selectRecommendedCompanies);
  const followedCompanies = useSelector(selectFollowedCompanies);
  const resultsEnded = useSelector(selectCompanyResultsEnded);

  const companiesSection = useSelector(companiesData);
  const { companies, count } = companiesSection;
  const scrollDivRef = useRef<HTMLDivElement>(null);
  const [searchPage, setSearchPage] = useState(1);
  const host = window.location.href;
  const startTime = getCurrentTime();

  const displayCompanies = queryData?.length
    ? companies : [...followedCompanies, ...recommendedCompanies];
  const dispatch = useDispatch();
  const refineQuery = (line: string) => line.trim().replace(/\s+/g, ' ');

  useEffect(() => {
    setSearchPage(1);
    dispatch(globalSearch.globalSearchResultsResetEmpty());
  }, [queryData]);

  const onSearching = (searchText: string) => {
    setQueryData(searchText);
    if (searchText.trim().length) {
      scrollDivRef.current?.scrollTo({ top: 0 });
      if (refineQuery(searchText) === refineQuery(queryData)) return;
      if (searchText !== '') {
        const obj: SearchResultsRequest = {
          page: 1,
          query: `company:${searchText}`,
          screenName: 'onboardingFollowCompany',
          defaultLanguage: getLangCookie(),
        };
        dispatch(globalSearch.globalSearchResults(obj));
        dispatch(flurryActions.callFlurryEvent(
          valueToObject('search_Enter_FollowCompany_Onboarding', startTime, {
            host,
          }),
        ));
      }
    } else {
      setQueryData('');
    }
  };
  const companiesCount = queryData ? count : displayCompanies?.length;
  const fetchMore = () => {
    if (!queryData) return;
    const obj: SearchResultsRequest = {
      page: searchPage + 1,
      query: `company:${queryData}`,
      screenName: 'onboardingFollowCompany',
      defaultLanguage: getLangCookie(),
    };
    dispatch(globalSearch.globalSearchResults(obj));
    setSearchPage(searchPage + 1);
  };
  const handleScroll = (): number => scrollDivRef.current?.scrollTop || 0;

  useEffect(() => {
    const scrollWrapperElement = scrollDivRef.current;
    scrollWrapperElement?.addEventListener('scroll', handleScroll);
    return () => {
      scrollWrapperElement?.removeEventListener('scroll', handleScroll);
    };
  }, [scrollDivRef]);

  return (
    <StyleWrapper className="onboarding-component-mapping-container">
      <div className="title-search-div">
        <h3 className="title-for-module">Follow at least 3 companies to proceed</h3>
        <AlertsSearch
          onSearching={onSearching}
          placeholderText="Add your accounts"
          margin="0px"
          query={queryData}
          customClass={classNames({ active: activeIndex > -1 })}
        />
      </div>
      <h6 className="title-heading">{`${queryData.length ? 'Searched Companies' : 'Recommended Companies'} (${companiesCount ?? 0})`}</h6>
      {displayCompanies?.length
        ? (
          <div
            className={classNames(
              'scroll-wrapper-onboarding-company',
              {
                emptyState: !companies?.length
                  && !(loading || companiesLoading) && queryData.length,
              },
            )}
            id="onboardingCompanyComponent"
            ref={scrollDivRef}
          >
            <InfiniteScroll
              hasMore={!resultsEnded}
              dataLength={displayCompanies?.length ?? 0}
              next={fetchMore}
              scrollableTarget="onboardingCompanyComponent"
              loader={false}
              className="infinite-scroll-component-onboarding"
            >
              <div
                className="onboarding-component-wrap company-wrap"
              >
                {displayCompanies?.length ? displayCompanies.map((company) => (
                  <div className={classNames('company-card component-card follow-company')}>
                    <CompanyCardLarge
                      companyData={company}
                      key={company?.companyId}
                      isSearch
                      disableNavigation
                      showDrawerIcon={false}
                      showSapIcon={false}
                    />
                  </div>
                )) : null}
                {(companiesLoading || loading) ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(() => (
                  <div className={classNames('company-card component-card follow-company')}>
                    <CompanySkeleton />
                  </div>
                )) : null}
              </div>
              {!companies?.length && !(loading || companiesLoading) && queryData.length ? (
                <NoDataFoundComponent firstText="Could not find any company." secondText="Please try again." />
              ) : null}
            </InfiniteScroll>

          </div>
        )
        : null}
      {!displayCompanies?.length
        ? (
          <div
            className={classNames('onboarding-component-wrap company-wrap', { emptyWrap: !companies?.length && !(loading || companiesLoading) && queryData.length })}
          >
            {(companiesLoading || loading) ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(() => (
              <div className={classNames('company-card component-card follow-company')}>
                <CompanySkeleton />
              </div>
            )) : null}
            {!companies?.length && !(loading || companiesLoading) && queryData.length ? (
              <NoDataFoundComponent firstText="Could not find any company." secondText="Please try again." />
            ) : null}
          </div>
        )
        : null}
    </StyleWrapper>
  );
};

export default FollowCompanyComponent;
